import { Mobile, Email, ErrorTriangle } from 'phx-core';

import { Component, Input, OnInit } from '@angular/core';

import { Session } from '@services/session';

import { RED_60 } from '@lib/colors';
import { refreshPage } from '@lib/utils';

import { GENERAL_UPSELL_DEFAULT_CONFIG, IGeneralUpsellConfig } from './general-upsell-config';

@Component({
  selector: 'general-upsell',
  styleUrls: ['general-upsell.component.scss'],
  templateUrl: './general-upsell.component.html',
})
export class GeneralUpsellComponent implements OnInit {
  @Input() public config: IGeneralUpsellConfig;

  public refreshPageCallback = refreshPage;
  public isUpsellLoading: boolean = true;
  public readonly RED_60: string = RED_60;
  public readonly EMAIL_ICON: string = Email;
  public readonly MOBILE_ICON: string = Mobile;
  public readonly ERROR_TRIANGLE_ICON: string = ErrorTriangle;

  constructor(private session: Session) { }

  public ngOnInit(): void {
    if (!this.config) {
      this.config = GENERAL_UPSELL_DEFAULT_CONFIG;
    }
  }

  public primaryCtaClick(): void {
    this.config.primaryCta.callback();
  }

  public secondaryCtaClick(): void {
    this.config.secondaryCta.callback();
  }

  public phoneClick(): void {
    this.config.accountManager.phoneClickCallback();
  }

  public emailClick(): void {
    this.config.accountManager.emailClickCallback();
  }

  public removeSpacesAndParenthesis(text: string): string {
    return text.replace(/[\s()-]/g, '');
  }
}